import type { CityConfig } from "../city-template/types";

export const frederickConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Frederick",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "frederick-md",
  route: "/frederick-md",
  title: "Emergency Passport Frederick, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Frederick, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Frederick, Urbana, Walkersville, Thurmont, and Middletown residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Frederick, MD",
  heroSubtitle: "Frederick travelers — from historic downtown professionals to I-70 corridor commuters to Catoctin Mountain families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Frederick County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20downtown%20Frederick%20Maryland%20with%20charming%20brick%20buildings%20along%20Patrick%20Street%2C%20Carroll%20Creek%20Promenade%20with%20water%20features%2C%20warm%20autumn%20afternoon%20lighting%2C%20professional%20urban%20photography%2C%20clean%20architectural%20details%2C%20no%20visible%20text%20or%20people%2C%20colorful%20storefronts%20and%20tree-lined%20pedestrian%20walkways%2C%20historic%20district%20atmosphere%20with%20a%20modern%20touch&width=1800&height=700&seq=frederick-hero-001&orientation=landscape",
  heroImageAlt: "Historic downtown Frederick Maryland along Patrick Street with charming brick buildings and Carroll Creek Promenade",
  geoPosition: "39.4143;-77.4105",
  geoPlacename: "Frederick, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 45–55 minutes from Frederick via I-270 S and I-495 S",
  },
  nearbyCitiesZips: [
    { name: "Frederick", zips: "21701, 21702, 21703, 21704, 21705, 21709" },
    { name: "Urbana", zips: "21704, 21754" },
    { name: "Walkersville", zips: "21793" },
    { name: "Thurmont", zips: "21788" },
    { name: "Middletown", zips: "21769" },
    { name: "Brunswick", zips: "21716, 21758" },
    { name: "Mount Airy", zips: "21771" },
    { name: "New Market", zips: "21774" },
    { name: "Jefferson", zips: "21755" },
    { name: "Buckeystown", zips: "21717" },
    { name: "Adamstown", zips: "21710" },
    { name: "Hagerstown", zips: "21740, 21741, 21742, 21747, 21749, 21750" },
    { name: "Westminster", zips: "21157, 21158" },
    { name: "Germantown", zips: "20874, 20875, 20876" },
    { name: "Gaithersburg", zips: "20877, 20878, 20879, 20882, 20883, 20884, 20885, 20898, 20899" },
    { name: "Rockville", zips: "20847, 20848, 20849, 20850, 20851, 20852, 20853, 20857" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Frederick and I-70 corridor departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-road-map-line", title: "I-70 & I-270 Corridor", desc: "Serving commuters and families along both major corridors" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Hagerstown, MD", route: "/hagerstown" },
    { name: "Emergency passport help in Gaithersburg, MD", route: "/gaithersburg" },
    { name: "Urgent passport services in Rockville, MD", route: "/rockville" },
    { name: "Maryland passport services overview", route: "/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Frederick, Maryland remotely via secure registered courier. We do not have a walk-in office in Frederick — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Frederick County travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Frederick, Urbana, Walkersville, Thurmont, Middletown, and greater Frederick County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Frederick area and greater Frederick County. From the historic downtown district along Patrick Street and Carroll Creek to the growing suburban communities of Urbana and Ballenger Creek, from the quiet rural towns of Walkersville and Thurmont to the scenic Catoctin Mountain area — we serve all of Frederick's diverse communities.",
  nearbyCitiesIntro: "We serve Frederick and nearby communities including Urbana, Walkersville, Thurmont, Middletown, Brunswick, Mount Airy, New Market, Jefferson, Buckeystown, and Adamstown. We also serve travelers in Hagerstown and Westminster, plus commuters in Germantown, Gaithersburg, and Rockville who prefer our expedited service.",
  howItWorksIntro: "Most Frederick travelers complete everything online and ship documents overnight. No need to drive 45–55 minutes to downtown DC or navigate the Capital Beltway during rush hour.",
  mistakesIntro: "Frederick is a growing commuter hub with a mix of historic downtown residents, suburban families, and I-70/I-270 corridor professionals. Here are the most common passport mistakes we see from Frederick travelers.",
  testimonialsIntro: "Frederick travelers — from downtown professionals to mountain families to corridor commuters — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Frederick, MD? Here are the most common ones we hear from Frederick County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Frederick County travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 45–55 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Frederick travelers with immediate departure needs — as fast as 24 hours. Perfect for last-minute business trips, family emergencies, and urgent travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Emergency travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Frederick adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Frederick address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Frederick residents and families — including students and young professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Frederick residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Frederick families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Frederick residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Frederick MD", description: "Urgent passport processing for Frederick Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Frederick MD", description: "Fast passport renewal for Frederick Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Frederick MD", description: "New passport application services for Frederick Maryland residents applying for their first passport." },
    { name: "Child Passport Frederick MD", description: "Minor passport services for Frederick Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Urbana, MD",
      rating: 5,
      text: "Business trip to Toronto in 5 days. Fast Passport Center caught a photo issue before submission and had my passport ready in 48 hours. Saved me from missing a critical client meeting.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel S.",
      location: "Frederick, MD",
      rating: 5,
      text: "Family vacation to Europe with 11 days notice. Four passports processed in under a week. The agent coordinated everything — we just dropped the docs at the UPS Store on Buckeystown Pike.",
      service: "Family Passport Bundle",
    },
    {
      name: "James K.",
      location: "Walkersville, MD",
      rating: 5,
      text: "Renewed my passport for a cruise with 8 days notice. Fast Passport Center had it back in 3 days. No need to drive to DC or Baltimore — everything shipped overnight.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda L.",
      location: "Thurmont, MD",
      rating: 5,
      text: "Last-minute family emergency required travel to Ireland. They understood the urgency and had my passport in my hands within 36 hours. Professional service that respects rural Frederick County timelines.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "frederick-1",
      name: "Frederick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Technology Dr",
      city: "Frederick",
      state: "MD",
      zip: "21701",
      phone: "(301) 631-2550",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Frederick area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Frederick acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "frederick-2",
      name: "Urbana Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3530 Sugarloaf Pkwy",
      city: "Frederick",
      state: "MD",
      zip: "21704",
      phone: "(301) 874-5530",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Urbana, approximately 5 miles southeast of downtown Frederick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Urbana and southern Frederick County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "frederick-3",
      name: "Walkersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11 Hope Hill Cir",
      city: "Walkersville",
      state: "MD",
      zip: "21793",
      phone: "(301) 898-5751",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Walkersville, approximately 6 miles northeast of downtown Frederick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Walkersville and northern Frederick County residents. Good alternative when downtown Frederick appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "frederick-4",
      name: "Frederick County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "100 W Patrick St",
      city: "Frederick",
      state: "MD",
      zip: "21701",
      phone: "(301) 600-1976",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Downtown Frederick, historic courthouse district",
      website: "https://www Frederick County MD.gov/",
      websiteLabel: "Frederick County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Located in the historic courthouse district.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45–55 min drive to downtown DC", fpc: "No — ship from Frederick" },
    { feature: "Commuter Flexibility", agency: "No flexibility for I-70 corridor schedules", fpc: "Yes — we handle everything remotely" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Frederick's busy commuters and professionals often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Frederick sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Frederick and Frederick County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Frederick Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Frederick residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Frederick, Urbana, or Walkersville." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Frederick or along Buckeystown Pike." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Frederick address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Frederick, MD?", a: "Fast Passport Center offers emergency passport processing in Frederick, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (45–55 minutes from Frederick) — without you needing to make the drive or fight Beltway traffic." },
    { q: "Does Frederick have its own passport agency?", a: "No — neither Frederick nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 45–55 minutes from Frederick via I-270 S. Fast Passport Center's courier service means Frederick residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Urbana or Walkersville?", a: "Absolutely. Fast Passport Center serves all of the Frederick area including Urbana, Walkersville, Thurmont, Middletown, Brunswick, and Mount Airy. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Frederick, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Frederick travelers use for international flights?", a: "Most Frederick residents fly internationally through Baltimore-Washington International (BWI), approximately 45–55 minutes southeast via I-70 E and I-695 S. Dulles International (IAD) is 40–50 minutes south via I-270 S and the Dulles Toll Road. Reagan National (DCA) is 50–60 minutes south via I-270 S. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Frederick?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Frederick, Urbana, Walkersville, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to downtown Frederick?", a: "The Frederick Post Office at 1000 Technology Dr is the primary downtown acceptance facility. The Frederick County Clerk's Office at 100 W Patrick St serves the historic courthouse district. The Urbana Post Office at 3530 Sugarloaf Pkwy serves southern Frederick County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Frederick residents should plan ahead, especially for summer vacations and holiday travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Frederick", address: "1205 W Patrick St, Frederick, MD 21702", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Frederick", address: "1305 W 7th St, Frederick, MD 21701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Frederick", address: "1300 W Patrick St, Frederick, MD 21702", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Frederick", address: "5599 Spectrum Blvd, Frederick, MD 21703", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Frederick", address: "1601 Bowmans Farm Rd, Frederick, MD 21701", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Frederick County and western Maryland. REAL ID processing available.", featured: true },
    { name: "MVA — Gaithersburg", address: "15 Metropolitan Grove Rd, Gaithersburg, MD 20878", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Montgomery County and southern Frederick County commuters. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "45–55 minutes from Frederick via I-70 E and I-695 S",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary airport for Frederick County travelers. Excellent domestic connections and international flights. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "40–50 minutes from Frederick via I-270 S and Dulles Toll Road",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub with direct flights to Europe, Asia, and South America. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "50–60 minutes from Frederick via I-270 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Closest airport for domestic connections. Limited international flights but excellent for connecting to major hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
  ],
};